import { useState } from 'react'

import { ProductCard as F1ProductCard } from '@factorialco/f0-react'

import { track } from 'modules/core/lib/Tracking'
import { trackingEvents } from 'modules/core/lib/Tracking/events'

import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { moduleAvailableToModuleId } from 'modules/upsell/lib/moduleIcons'
import { ProductModal } from 'modules/upselling_kit/components/ProductModal'
import { UpsellGuard } from 'modules/upselling_kit/components/UpsellGuard'
import { useGetUpsellingData } from 'modules/upselling_kit/hooks/useGetUpsellingData'
import { UpsellingKitProductCard } from 'modules/upselling_kit/types'
import {
  handleUpsellingOnClick,
  handleUpsellingOnClose,
} from 'modules/upselling_kit/utils/handlers'

const ProductCardContent = ({
  moduleRequested,
  title,
  description,
  dismissible,
  requestSource,
  onClick,
  onClose,
}: UpsellingKitProductCard) => {
  const { moduleName, moduleDescription } = useGetUpsellingData({
    moduleRequested,
    title,
    description,
  })

  const [openUpsellModal, setOpenUpsellModal] = useState(false)

  const moduleId = moduleAvailableToModuleId(moduleRequested)
  return (
    <>
      <F1ProductCard
        title={moduleName || ''}
        description={moduleDescription || ''}
        module={moduleId}
        onClick={() =>
          handleUpsellingOnClick({
            onClick,
            requestSource,
            moduleRequested,
            component: 'product_card',
            setOpenUpsellModal,
          })
        }
        dismissable={dismissible}
        isVisible
        trackVisibility={(open: boolean) => {
          if (open) {
            track(trackingEvents.upsellingKit.viewedProductUpsellComponent, {
              source: requestSource,
              module: moduleRequested,
              component: 'product_card',
            })
          }
        }}
        onClose={() =>
          handleUpsellingOnClose({
            onClose,
            requestSource,
            moduleRequested,
            component: 'product_card',
          })
        }
      />
      {openUpsellModal && (
        <ProductModal
          requestReason={ValidReasons.MissingAddon}
          moduleRequested={moduleRequested}
          requestSource={requestSource}
          onClose={() => setOpenUpsellModal(false)}
          pageSource={requestSource}
          isOpen={openUpsellModal}
          upsellRequestComponentType="product_card"
        />
      )}
    </>
  )
}

const ProductCard = ({
  title,
  description,
  dismissible,
  onClick,
  onClose,
  fallbackComponent,
  ...upsellProps
}: UpsellingKitProductCard) => {
  return (
    <UpsellGuard {...upsellProps} fallbackComponent={fallbackComponent || null}>
      <ProductCardContent
        {...upsellProps}
        title={title}
        description={description}
        dismissible={dismissible}
        onClick={onClick}
        onClose={onClose}
      />
    </UpsellGuard>
  )
}

export { ProductCard }
